import { queryOptions } from '@tanstack/react-query';
import { z } from 'zod';
import { api } from '@/shared/api/client';

export const jobStatusSchema = z.object({
  id: z.string().optional(),
  _id: z.string().optional(),
  function: z.string().nullish(),
  name: z.string().nullish(),
  status: z.string().nullish(),
  lastLaunchDate: z.string().nullish(),
});

export type JobStatus = z.infer<typeof jobStatusSchema>;

/** Internal export job, never shown on the Interface screen. */
export const HIDDEN_FUNCTIONS = ['DMSExcelExport'] as const;

export const fetchJobStatuses = async (): Promise<JobStatus[]> => {
  const items = await api.get<JobStatus[] | null>('interface', {
    schema: z.array(jobStatusSchema).nullable(),
  });
  return (items ?? []).filter(
    (item) =>
      !HIDDEN_FUNCTIONS.includes(
        item.function as (typeof HIDDEN_FUNCTIONS)[number],
      ),
  );
};

export const INTERFACE_REFRESH_MS = 30_000;

export const jobStatusesQueryOptions = () =>
  queryOptions({
    queryKey: ['interface', 'job-statuses'] as const,
    queryFn: fetchJobStatuses,
    refetchInterval: INTERFACE_REFRESH_MS,
    retry: false,
  });
